var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GET_ZONE_RATE_REQUEST, getZoneRateFailure, getZoneRateSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
export const onGetZoneRateFile = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.downloadLabel(`/rms/admin/uploaded/file?filePath=${action.payload.filePath}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* GetZoneRateFileWorker(action) {
    try {
        const data = yield call(onGetZoneRateFile, action);
        yield put(getZoneRateSuccess(data));
    }
    catch (error) {
        yield put(getZoneRateFailure(error));
    }
}
export function* watchGetZoneRateFileData() {
    yield takeLatest(GET_ZONE_RATE_REQUEST, GetZoneRateFileWorker);
}
